import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      icon: "Search",
      title: "Search & Browse",
      description: "Find the perfect trailer by location, type, and availability dates using our powerful search engine"
    },
    {
      id: 2,
      icon: "Calendar",
      title: "Book Your Dates",
      description: "Select your rental period and confirm availability with instant booking confirmation"
    },
    {
      id: 3,
      icon: "CreditCard",
      title: "Secure Payment",
      description: "Complete your booking with secure payment processing and receive instant confirmation"
    },
    {
      id: 4,
      icon: "Truck",
      title: "Pick Up & Go",
      description: "Meet the owner, inspect the trailer, and hit the road with your rental"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
            How It Works
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Renting a trailer has never been easier. Follow these simple steps to get started
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps?.map((step, index) => (
            <div key={step?.id} className="relative">
              <div className="bg-card rounded-lg p-6 md:p-8 shadow-elevation-2 transition-smooth hover:shadow-elevation-3 h-full">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-primary rounded-full flex items-center justify-center mb-4 md:mb-6 shadow-elevation-2">
                    <Icon name={step?.icon} size={32} color="white" strokeWidth={2} className="md:w-10 md:h-10" />
                  </div>

                  <div className="absolute top-4 right-4 w-8 h-8 bg-accent text-accent-foreground rounded-full flex items-center justify-center font-heading font-bold text-lg">
                    {step?.id}
                  </div>

                  <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-3">
                    {step?.title}
                  </h3>

                  <p className="font-body text-sm md:text-base text-muted-foreground">
                    {step?.description}
                  </p>
                </div>
              </div>

              {index < steps?.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <Icon name="ArrowRight" size={24} color="var(--color-primary)" strokeWidth={2} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;